import { ImportDropdown } from "components/Importer/ImportDropdown";
import { WasteManifestImporter } from "components/WasteManifestImporter";
import { OneSchemaTemplateType } from "encamp-shared/src/oneSchema/types";

import { WASTE_LINES_UNIFIED_QUERY } from "./api";

export const ImportButton = function () {
  return (
    <ImportDropdown
      key="import"
      color="staff"
      importers={[
        {
          name: "Vendor",
          importer: (
            <WasteManifestImporter
              templateType={OneSchemaTemplateType.OtherWasteManifest}
              label="Vendor"
              refetchQueries={[WASTE_LINES_UNIFIED_QUERY]}
              mode="dropdown"
            />
          ),
        },
      ]}
    />
  );
};
